// extracted by mini-css-extract-plugin
export default {"info":"AllInfoComponent_info__vbt5w","copyBtn":"AllInfoComponent_copyBtn__skdpI"};